<template>
  <div v-if="selectedPlan !== null && selectedPlan !== undefined">
    <v-dialog v-model="dialog" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">{{ $t("globals.cancel_wizard") }}</v-card-title>
        <v-card-text>
          {{
          $t(
          "views.billingwizard.if_you_exit_the_wizard_any_changes_made_so_far"
          )
          }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color text @click="dialog = false">
            {{
            $t("globals.keep_working")
            }}
          </v-btn>
          <v-btn color="primary" @click="cancel()">
            {{
            $t("globals.cancel_anyway")
            }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="with-margin">
      <material-card :title="$t('views.t4awizard.wizard_title_{0}', [trans(selectedPlan, 'Name')])" :color="$vuetify.theme.themes.light.secondary" icon="post_add" elevation="0">
        <v-card-text>{{ $t('views.t4awizard.wizard_subtitle_{0}', [trans(selectedPlan, 'Name')]) }}</v-card-text>
        <v-stepper v-model="e6" vertical>
          <v-stepper-step :complete="e6 > 1" step="1">
            {{
            $t("views.t4awizard.initiate_t4a_wizard")
            }}
          </v-stepper-step>

          <v-stepper-content step="1">
            <v-card>
              <v-card-text v-if="step1SuccessMessage">
                {{
                step1SuccessMessage
                }}
              </v-card-text>
              <v-card-text v-if="step1ErrorMessage">
                {{
                step1ErrorMessage
                }}
              </v-card-text>
              <v-card-actions>
                <v-btn text @click="dialog = true">{{ $t("globals.cancel") }}</v-btn>

                <v-btn
                  :loading="loading"
                  color="primary"
                  :disabled="!step1SuccessMessage"
                  @click="goToStep2()"
                >{{ $t("globals.continue") }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-stepper-content>

          <v-stepper-step :complete="e6 > 2" step="2">
            {{
            $t("views.t4awizard.t4a_report_table")
            }}
          </v-stepper-step>

          <v-stepper-content step="2">
            <material-card
              :title="$t('views.t4awizard.t4a_report')"
              :color="$vuetify.theme.themes.light.secondary"
              icon="post_add"
              v-if="year !== null && year !== undefined"
              elevation="0"
            >
              <t4areporttable
                :identifier="selectedPlan.Id + '_t4aWizardTable'"
                :url="reportUrl"
                :year="year.Id"
                v-if="reportUrl"
              ></t4areporttable>
              <v-card-actions>
                <!--v-btn text @click="dialog=true">{{$t('Cancel')}}</v-btn>
                <v-btn text @click="e6 = 1">{{$t('globals.back')}}</v-btn-->
                <v-btn color="primary" @click="finish()">
                  {{
                  $t("globals.finish")
                  }}
                </v-btn>
              </v-card-actions>
            </material-card>
          </v-stepper-content>
        </v-stepper>
      </material-card>
      <error-handler :error="error"></error-handler>
    </div>
  </div>
  <div v-else>
    <v-row justify="center">
      <v-progress-circular
        :size="70"
        :width="7"
        color="accent"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import t4areporttable from "../components/T4AReportTable";
import ErrorHandler from "../components/ErrorHandler";
import { locker } from "../mixins/locker";
import {translate2} from "../trans2";
import { planSetter } from "../mixins/planSetter";

export default {
  name: "t4a-wizard",
  components: {
    t4areporttable,
    ErrorHandler
  },
  mixins: [locker, planSetter],
  data() {
    return {
      error: null,
      step1SuccessMessage: null,
      step1ErrorMessage: null,
      loading: false,
      year: null,
      dialog: false,
      e6: 1,
      reportUrl: null
    };
  },
  computed: {
    ...mapGetters("common", ["messages"]),
    ...mapGetters("common", { selectedPlan: "plan" }),
    ...mapGetters("plansMembers", { planParameters: "planOptions" })
  },
  watch: {
    selectedPlan: {
      handler() {
        this.loadPlanData();
      }
    }
  },
  mounted() {
    if (this.selectedPlan !== null && this.selectedPlan !== undefined) {
      this.loadPlanData();
    }
  },
  methods: {
    trans(item, field) {
      return translate2(item, field);
    },
    ...mapActions("plansMembers", ["getT4ACalculationYear", "calculateT4A"]),
    async loadPlanData() {
      this.loading = true;
      try {
        this.year = await this.lock(
          this.getT4ACalculationYear,
          this.selectedPlan.Id,
          () => {
            this.$router.push({ name: "reports", params: { planId: this.selectedPlan.Id } });
          }
        );
        this.step1SuccessMessage =
          this.$t('views.t4awizard.t4a_success_{0}', [this.year.Year.toString()]);
        this.e6 = 1;
      } catch (error) {
        console.log(error);
        if (error.response.status === 409 && error.response.data.Code === 400) {
          this.step1ErrorMessage = this.$t("views.t4awizard.step1error");
        } else {
          this.error = error;
        }
      }
      this.loading = false;
    },

    async goToStep2() {
      this.loading = true;
      try {
        await this.calculateT4A({
          plan: this.selectedPlan.Id,
          year: this.year.Id
        });
        this.unlock();
        this.loading = true;
        //console.log("calculated");
        this.reportUrl =
          "plans/" + this.selectedPlan.Id + "/t4aForYear/" + this.year.Id;
        this.e6 = 2;
        //console.log(this.reportUrl);
      } catch (error) {
        this.error = error;
      }
    },
    cancel() {
      /*this.$refs.form.reset()
        this.e6=1
        this.selectedPlan = null*/
      this.dialog = false;
      this.$router.push({ name: "reports", params: { planId: this.selectedPlan.Id } });
    },
    finish() {
      this.$router.push({ name: "reports", params: { planId: this.selectedPlan.Id } });
    }
  }
};
</script>

<style>
.with-margin {
  margin: 20px;
}
</style>
